<a [routerLink]="link" class="block w-full " [attr.aria-label]="'View offer: ' + title">
    <article (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" class="sm:h-[30.2rem] h-[52.2rem] w-full shadow-sm group">
        <div class="overflow-hidden rounded-t-[var(--dsr-radius-medium)] sm:h-[25.2rem] h-[42.2rem] w-full group-hover:opacity-85 flex items-center justify-center relative">
            
            <div class="sm:h-[25.2rem] h-[42.2rem] w-full bg-red-200 overflow-hidden absolute rounded-t-[var(--dsr-radius-small)]">
                
                <div [ngStyle]="{'background-image': 'url(' + backgroundImg + ')'}"
                    class="absolute transform transition-transform duration-300 group-hover:scale-[1.15] bg-cover sm:h-[25.2rem] h-[42.2rem] w-full" role="img" [attr.aria-label]="title + ' offer background'">
                    <img [src]="backgroundImg" [alt]="title + ' offer illustration'" class="hidden">
                </div>

                <div class="sm:h-[25.2rem] h-[42.2rem] w-full absolute bg-black opacity-60" aria-hidden="true"></div>
            </div>
            
            <div class="h-full text-center flex flex-col items-center justify-center text-white dsr-typescale-title-small  font-[700] relative">
                <span>{{title}}</span>
                <span class="dsr-typescale-body-small text-white sm:px-[2rem] px-[4rem] mt-[1.2rem] w-full hidden group-hover:block transition-opacity duration-300">
                    {{description | translate}}
                </span>
            </div>

        </div>

        <div class="flex  rounded-b-[var(--dsr-radius-medium)] bg-white group-hover:bg-black group-hover:text-white justify-around items-center sm:h-[5rem] h-[10rem] relative border-solid border-b-[0.01rem]">
            <div class="w-full text-center sm:text-[1.4rem] text-[3rem] font-[600]">
                <span class="uppercase"> {{'MORE_INFO_TEXT' | translate}} </span>
            </div>
            <dsr-icon #rt name="arrow-right-1" size="3rem" [color]="arrowColor" class="hover:cursor-pointer absolute right-[0.4rem] sm:right-[0.2rem]" aria-hidden="true" />
        </div>
    </article>
</a>